(() => {
  /* Branded "Sort by" dropdown: replaces the browser's plain list, keeps the real <select> for the theme's filtering */
  // One outside-click listener; detached filter menus are not retained by document.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.bz-sort').forEach((box) => {
      if (box.contains(event.target)) return;
      const list = box.querySelector('.bz-sort__list');
      const button = box.querySelector('.bz-sort__btn');
      if (list && !list.hidden) {
        list.hidden = true;
        button?.setAttribute('aria-expanded', 'false');
      }
    });
  });
  const enhance = () => {
    document.querySelectorAll('select.facet-filters__sort').forEach((select) => {
      const wrap = select.closest('.select');
      if (!wrap || wrap.dataset.bzSort === 'true') return;
      wrap.dataset.bzSort = 'true';
      wrap.classList.add('bz-sorted');

      const box = document.createElement('div');
      box.className = 'bz-sort';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bz-sort__btn';
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      const label = document.createElement('span');
      button.append(label);
      button.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>');
      const list = document.createElement('ul');
      list.className = 'bz-sort__list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;

      const refresh = () => {
        const current = select.options[select.selectedIndex];
        label.textContent = current ? current.textContent.trim() : '';
        list.querySelectorAll('[role="option"]').forEach((item) => {
          item.setAttribute('aria-selected', item.dataset.value === select.value ? 'true' : 'false');
        });
      };
      [...select.options].forEach((option) => {
        const item = document.createElement('li');
        item.className = 'bz-sort__opt';
        item.setAttribute('role', 'option');
        item.tabIndex = -1;
        item.dataset.value = option.value;
        item.innerHTML = '<span></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
        item.firstChild.textContent = option.textContent.trim();
        list.append(item);
      });

      const close = (focusButton) => {
        list.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        if (focusButton) button.focus();
      };
      const open = () => {
        list.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        const selected = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
        if (selected) selected.focus();
      };
      const choose = (item) => {
        if (!item) return;
        close(true);
        if (select.value === item.dataset.value) return;
        select.value = item.dataset.value;
        refresh();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      button.addEventListener('click', () => (list.hidden ? open() : close(false)));
      list.addEventListener('click', (event) => choose(event.target.closest('[role="option"]')));
      list.addEventListener('keydown', (event) => {
        const items = [...list.children];
        const index = items.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          (items[index + 1] || items[0]).focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          (items[index - 1] || items[items.length - 1]).focus();
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          choose(document.activeElement.closest('[role="option"]'));
        } else if (event.key === 'Escape' || event.key === 'Tab') {
          close(event.key === 'Escape');
        }
      });
      select.addEventListener('change', refresh);

      box.append(button, list);
      wrap.after(box);
      refresh();
    });
  };

  const start = () => {
    enhance();
    /* Only pages with filters need watching, and only the filter area (it is redrawn after each filter change) */
    const area = document.querySelector('#main-search-filters, #main-collection-filters, .facets-wrapper');
    if (!area) return;
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(enhance, 60);
    }).observe(area, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();